import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { UserInactivityService } from 'src/app/services/user-inactivity/user-inactivity.service';

@Component({
  selector: 'app-inactivity-warning',
  templateUrl: './inactivity-warning.component.html',
  styleUrls: ['./inactivity-warning.component.scss'],
})
export class InactivityWarningComponent implements OnInit, OnDestroy {
  visible = false;
  secondsRemaining = 10;
  inactivityDurationLabel = '';

  private warningSub?: Subscription;
  private countdownSub?: Subscription;

  constructor(private userInactivityService: UserInactivityService) {}

  ngOnInit(): void {
    this.inactivityDurationLabel = this.userInactivityService.inactivityDurationLabel;

    this.warningSub = this.userInactivityService.warningVisible$.subscribe((visible) => {
      this.visible = visible;
    });
    this.countdownSub = this.userInactivityService.secondsRemaining$.subscribe((seconds) => {
      this.secondsRemaining = seconds;
    });
  }

  stayLoggedIn(): void {
    this.userInactivityService.stayLoggedIn();
  }

  ngOnDestroy(): void {
    this.warningSub?.unsubscribe();
    this.countdownSub?.unsubscribe();
  }
}
